
/**
 * `BannerTeaser` - Banner Teaser Component.
 * For now this is just a owc wrapper component - This component uses workbench wb-banner-teaser.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { BannerTeaserComponent, BannerTeaserLink } from './BannerTeaser';
import { CTAButton, TagType } from './BannerTeaser.enums';
import { IMAGE_RATIO_DEFAULT } from '../src/BannerTeaser.config';
import GenericImageGenerator from '@owc-utils/GenericImage/GenericImageGenerator';
import GenericImageComponent from '@owc-packages/GenericImage/src/GenericImage.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import Personalisation from '@owc-utils/Mixins/Personalisation';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { getLocalFootnotes, setModuleId } from '@owc-utils/Footnotes/FootnotesHelper';
import { setBrandTheme } from '@owc-utils/Theming/theming';

export default (ComponentInitializeDispatcher as BannerTeaserComponent).extend({
  name: 'owc-banner-teaser',
  components: {
    GenericImageComponent,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent, Personalisation],
  computed: {
    image: function() {
      const image = this.personaliseableData?.image;

      if (!image) {
        return null;
      }

      return new GenericImageGenerator(image, [], IMAGE_RATIO_DEFAULT);
    },
    headline: function() {
      return this.personaliseableData?.headline || '';
    },
    copy: function() {
      return this.personaliseableData?.copy || '';
    },
    isDarkMode: function() {
      return Boolean(this.personaliseableData?.darkMode);
    },
    ctaBtns: function() {
      return this.personaliseableData?.links || [];
    },
    ctaPrimary: function() {
      return this.ctaBtns.find((ctaBtn: BannerTeaserLink) => ctaBtn.type === CTAButton.primary);
    },
    ctaSecondary: function() {
      return this.ctaBtns.find((ctaBtn: BannerTeaserLink) => ctaBtn.type === CTAButton.secondary);
    },
    tags: function() {
      return this.personaliseableData?.tags || [];
    },
    footnotes() {
      return getLocalFootnotes(this.personaliseableData);
    },
    moduleId() {
      return setModuleId(this);
    },
    brand() {
      return setBrandTheme();
    },
  },
  methods: {
    getTagClassByType(tagType: number) {
      return TagType[tagType] || '';
    },
  },
});
